import { RoutePath } from "data/router/paths";
import useCustomNavigate from "hooks/common/useCustomNavigate";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { authStore } from "stores/auth-stores";

export default function LoginRoutes() {
  const { loginStatus } = authStore();
  const [isLogin, setIsLogin] = useState(false);
  const { navigateToReplacePath } = useCustomNavigate();
  useEffect(() => {
    setIsLogin(loginStatus);
    if (loginStatus) {
      navigateToReplacePath(RoutePath.ripeness);
    } else {
      navigateToReplacePath(RoutePath.login);
    }
  }, [loginStatus]);

  return isLogin ? (
    <></>
  ) : (
    <>
      <Outlet></Outlet>
    </>
  );
}
